/** UI strings for content updates, the journal grid, the voice survey and skill-journey captures (cu. jrg. voice. sj.). */
export const en = {
  /* Content update notice */
  'cu.title': 'New lessons are here!',
  'cu.titleN': '{n} new lessons are here!',
  'cu.titleOne': 'A new lesson is here!',
  'cu.update': 'Open them',
  'cu.later': 'Later',
  'cu.updated': 'Lessons updated',

  /* Journal grid */
  'jrg.grid': 'Grid',
  'jrg.book': 'Book',
  'jrg.count': '{n} drawings',
  'jrg.itemFull': 'This drawing already has {n} stickers',

  /* Voice survey */
  'voice.record': 'Record my idea',
  'voice.stop': 'Stop',
  'voice.left': '{s} s left',
  'voice.max': 'Up to {n} seconds',
  'voice.rerecord': 'Record again',
  'voice.send': 'Send my idea',
  'voice.typeInstead': 'Type it instead',
  'voice.speakInstead': 'Say it instead',
  'voice.noMic': 'There is no microphone here, so let us type the idea.',
  'voice.denied': 'Sketchling cannot hear you: the microphone is not allowed.',
  'voice.deniedHow': 'Ask a grown-up to allow the microphone for this app in the browser or phone settings, then try again. You can also type your idea.',
  'voice.retry': 'Try again',
  'voice.sending': 'Sending…',
  'voice.failed': 'That did not send. Check the internet and try again.',
  'voice.listen': 'Listen to your idea',
  'voice.length': 'Your idea: {s} s',

  /* Skill journey */
  'sj.trail': 'Practice trail',
  'sj.step': 'Step {n}',
  'sj.capture': 'Capture my practice',
  'sj.recapture': 'Capture again',
  'sj.locked': 'Finish the step before this one first',
  'sj.progress': '{done}/{total} steps captured',
  'sj.beforeAfter': 'Before and after',
  'sj.before': 'Before',
  'sj.after': 'After',
  'sj.complete': 'Journey complete! You practised every step.',
  'sj.saved': 'Practice saved: +{n} skill points',
  'sj.savedAgain': 'New practice photo saved',
  'sj.reference': 'Look at this lesson for ideas',
  'sj.disabled': 'Practice trails are resting right now.',

  /* Cheats */
  'dbg.lab': 'Interactive lab',
  'dbg.contentCheck': 'Check for new lessons',
};

export const vi: Record<keyof typeof en, string> = {
  'cu.title': 'Có bài học mới rồi!',
  'cu.titleN': 'Có {n} bài học mới rồi!',
  'cu.titleOne': 'Có một bài học mới rồi!',
  'cu.update': 'Mở ngay',
  'cu.later': 'Để sau',
  'cu.updated': 'Đã cập nhật bài học',

  'jrg.grid': 'Lưới',
  'jrg.book': 'Sổ',
  'jrg.count': '{n} bức vẽ',
  'jrg.itemFull': 'Bức vẽ này đã có {n} nhãn dán',

  'voice.record': 'Ghi âm ý tưởng',
  'voice.stop': 'Dừng',
  'voice.left': 'Còn {s} giây',
  'voice.max': 'Tối đa {n} giây',
  'voice.rerecord': 'Ghi lại',
  'voice.send': 'Gửi ý tưởng',
  'voice.typeInstead': 'Gõ chữ thay vì nói',
  'voice.speakInstead': 'Nói thay vì gõ',
  'voice.noMic': 'Ở đây không có micrô, mình gõ ý tưởng nhé.',
  'voice.denied': 'Sketchling không nghe được con: micrô chưa được cho phép.',
  'voice.deniedHow': 'Nhờ người lớn cho phép micrô cho ứng dụng trong cài đặt trình duyệt hoặc điện thoại rồi thử lại. Con cũng có thể gõ ý tưởng.',
  'voice.retry': 'Thử lại',
  'voice.sending': 'Đang gửi…',
  'voice.failed': 'Chưa gửi được. Kiểm tra mạng rồi thử lại nhé.',
  'voice.listen': 'Nghe lại ý tưởng',
  'voice.length': 'Ý tưởng của con: {s} giây',

  'sj.trail': 'Chặng luyện tập',
  'sj.step': 'Bước {n}',
  'sj.capture': 'Chụp bài luyện tập',
  'sj.recapture': 'Chụp lại',
  'sj.locked': 'Hoàn thành bước trước đã nhé',
  'sj.progress': 'Đã chụp {done}/{total} bước',
  'sj.beforeAfter': 'Trước và sau',
  'sj.before': 'Trước',
  'sj.after': 'Sau',
  'sj.complete': 'Hoàn thành chặng! Con đã luyện tập mọi bước.',
  'sj.saved': 'Đã lưu bài luyện: +{n} điểm kỹ năng',
  'sj.savedAgain': 'Đã lưu ảnh luyện tập mới',
  'sj.reference': 'Xem bài học này để lấy ý tưởng',
  'sj.disabled': 'Chặng luyện tập đang tạm nghỉ.',

  'dbg.lab': 'Phòng thử tương tác',
  'dbg.contentCheck': 'Kiểm tra bài học mới',
};
